import Input from './Input';
import withKeyboard from 'Common/Components/Keyboard/withKeyboard';
import { withIgnoreKeypadInput } from 'PointOfSale/modules/common/component/withIgnoreKeypadInput';

export default withIgnoreKeypadInput(withKeyboard(Input));



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/KeyboardInput.js